import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(localStorage.getItem("token"));
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  const setToken = (newToken) => {
    if (newToken) {
      localStorage.setItem("token", newToken);
      setTokenState(newToken);
    } else {
      localStorage.removeItem("token");
      setTokenState(null);
      setRole(null);
    }
  };

  useEffect(() => {
    const fetchRole = async () => {
      if (!token) {
        setLoading(false);
        return;
      }

      try {
        // const res = await authService.getProfile();
        const res = { data: { role: "admin" } };
        setRole(res.data.role);
      } catch (err) {
        setToken(null);
      } finally {
        setLoading(false);
      }
    };

    fetchRole();
  }, [token]);

  return (
    <AuthContext.Provider value={{ token, setToken, role, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
export const useAuth = () => useContext(AuthContext);
